// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_array = require("rescript/lib/js/caml_array.js");

function useClientHeightObserver(ref, onClientHeightChange) {
  React.useEffect((function () {
          var domElem = ref.current;
          if (domElem == null) {
            return ;
          }
          var observer = new ResizeObserver((function (mutations) {
                  if (mutations.length !== 0) {
                    return Curry._1(onClientHeightChange, Caml_array.get(mutations, mutations.length - 1 | 0).target.clientHeight);
                  }
                  
                }));
          observer.observe(domElem);
          return (function (param) {
                    observer.disconnect();
                  });
        }), [ref.current]);
}

exports.useClientHeightObserver = useClientHeightObserver;
/* react Not a pure module */
